import React from "react";
import { Box } from "@mui/material";
import AppsOutlined from "@mui/icons-material/AppsOutlined";
import { bkdp } from "../theme";

export type AppIconTileProps = {
  icon?: React.ElementType;
  color?: string;
  /** NAV-2: two named sizes only. "card" is the 44 px box the card grids align on; "nav" is the 24 px mark in the left navigation. */
  size?: "card" | "nav";
};

// NAV-2 criterion 4: a lookup, not a calculation. A third size is a decision, not a number.
const SIZES = {
  card: { box: 44, glyph: 28 },
  nav: { box: 24, glyph: 20 }
} as const;

/**
 * A fixed-size transparent container that renders an application's icon on
 * whatever is behind it (NAV-1: no plate). `icon` and `color` are optional:
 * omitting either falls back to the neutral default (AppsOutlined at
 * bkdp.slate). Decorative — aria-hidden.
 */
export function AppIconTile({ icon: Icon, color, size = "card" }: AppIconTileProps) {
  const GlyphIcon = Icon ?? AppsOutlined;
  const resolvedColor = color ?? bkdp.slate;
  const dims = SIZES[size];
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: dims.box,
        height: dims.box,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      }}
    >
      <Box
        component={GlyphIcon as React.ElementType}
        sx={{ fontSize: dims.glyph, color: resolvedColor, display: "block" }}
      />
    </Box>
  );
}
